import React from "react";
import ImageGallery from "react-image-gallery";
import { $t } from '@/modules/i18n';

import "react-image-gallery/styles/css/image-gallery.css";

// https://github.com/xiaolin/react-image-gallery

class Gallery extends React.Component {
  render() {
    const { message } = this.props
    return (
      <section
        id="gallery"
      >
        <div className="container d-flex justify-content-center">
          <div className="col-md-12">
            <div className="section-title">
              <h2>{$t(message.title)}</h2>
            </div>
            <ImageGallery
              items={message.images}
              showFullscreenButton={false}
              showPlayButton={false}
              autoPlay={true}
              slideInterval={6000}
            />
          </div>
        </div>
      </section>
    );
  }
}

export default Gallery;
